import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide
} from '@material-ui/core'
import { DashboardAthenaTable } from './DashboardAthenaTable'
import { resourceEmprelCoachingsCols, resourceUserFieldsCols } from '../constants/ResourceCols'
import CommentDialog from './CommentDialog'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

export default function ResourceEmprelCoachings(props) {
  const { headers, tableRefreshKey } = props

  const [customFieldsDialog, setCustomFieldsDialog] = useState({
    isOpen: false,
    uniqueId: null,
    userFieldClass: null
  })

  const tableDataTransformation = rows => {
    return rows.map(row => ({
      ...row,
      CUSTOM_FIELDS_LINK: (
        <div
          className='editLink'
          onClick={() => setCustomFieldsDialog({
            isOpen: true,
            uniqueId: row.UNIQUEID,
            userFieldClass: row.USERFIELD_CLASS
          })}
        >
          View
        </div>
    ),
    COMMENTS_LINK: (
      <CommentDialog
      {...props}
        erp="landmark"
        text="view"
        module="hr"
        screen="resource"
        entity="coaching"
        id={row.UNIQUEID}
      />
    ),
    }))
  }

  return (
    <div>
      <Dialog
        open={customFieldsDialog.isOpen}
        TransitionComponent={Transition}
        maxWidth='xl'
        scroll='body'
        keepMounted
        onClose={() => setCustomFieldsDialog({ isOpen: false, uniqueId: null, userFieldClass: null })}
      >
        <DialogTitle>Custom Fields</DialogTitle>
        <DialogContent>
          {customFieldsDialog.uniqueId && (
            <DashboardAthenaTable
              {...props}
              isTempTable={false}
              key={customFieldsDialog.uniqueId}
              params={{ uniqueId: customFieldsDialog.uniqueId, userFieldClass: customFieldsDialog.userFieldClass }}
              tableColumns={resourceUserFieldsCols}
              reportName='user_fields'
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            color='primary'
            onClick={() => setCustomFieldsDialog({ isOpen: false, uniqueId: null, userFieldClass: null })}
            className='primaryVLButton'
            variant='contained'
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <DashboardAthenaTable
        {...props}
        isTempTable={false}
        key={`emprel-coachings-${tableRefreshKey}`}
        params={{ ...headers }}
        tableColumns={resourceEmprelCoachingsCols}
        reportName='hr_resource_emprel_coachings'
        transform={tableDataTransformation}
      />
    </div>
  )
}
